module.exports = __webpack_public_path__ + "img/white-add-icon.df0733ab.svg";